<div *ngFor="let product of products">
	  <mat-card class="product-card" style="margin-left: auto; margin-right: auto; margin-bottom: 20px">
		  <mat-card-header>
			  <mat-card-title>{{ product.fields.productName }}</mat-card-title>
			  <mat-card-subtitle>Hinta: {{ product.fields.price }} euroa, {{ product.fields.availability }}</mat-card-subtitle>
		  </mat-card-header>
		  <img mat-card-image src="{{ product.fields.image[0].fields.file.url }}" alt="{{ product.fields.productName }}">
		  <mat-card-content>
			  <p>{{ product.fields.productDescription }}</p>
		  </mat-card-content>
	  </mat-card>
</div>
